module.exports = __webpack_public_path__ + "img/screen_2.1954262f.png";